import { render, staticRenderFns } from "./CaseJingmeiView.vue?vue&type=template&id=f1b80422"
import script from "./CaseJingmeiView.vue?vue&type=script&lang=js"
export * from "./CaseJingmeiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports